import React, { useState } from "react";
import styles from "./Styles";
import ReactModal from "react-modal";
import RadioBoxEmpty from "../../controls/check-boxes/RadioBoxEmpty";
import {
    OnestMediumDefault,
    OnestNormalSmall,
    OnestNormalMed,
    OnestNormalDefault,
} from "../../styled/TextComponents";
import { Button } from "../../controls/Button/Button";
import { 
    color_white, 
    color_grey_light, 
    color_red_default 
} from "../../../constants/colors";

import { ClipLoader } from "react-spinners";
import { useWindowDimensions } from "../../../utils";
import { MODAL_Z_INDEX_BASE } from "../../../constants/layers";
import {
    bottomSheetDragHandleVisualStyle,
    useBottomSheetDrag,
} from "../../../hooks/useBottomSheetDrag";
import { useI18n } from "../../../i18n/I18nProvider";


const ModalNote = ({isOpen, onClose, onSave, lessonData}) => {
    const { t } = useI18n();
    const { width: screenWidth } = useWindowDimensions();
    const isMobile = screenWidth <= 500;
    const isSmallMobile = screenWidth <= 375;
    const desktopModalWidth = 418;
    const desktopModalHeight = 497;
    const desktopInnerWidth = 358;
    
    const [comment, setComment] = useState(lessonData.note || "");
    const [commentOption, setCommentOption] = useState("lesson");
    const [ isButtonDisabled, setIsButtonDisabled ] = useState(true);

    const { dragHandleProps, sheetMotionStyle, resetDrag } = useBottomSheetDrag({
        enabled: isMobile,
        onClose,
    });


    const [isSpineActive, setIsSpineActive] = useState(false);
    
    //console.warn("lessonData", lessonData);

    const handleCommentSubmit = async () => {
        
        setIsSpineActive(true);
        await onSave(comment, commentOption, lessonData);
        setIsButtonDisabled(true);
        onClose();
        
        setIsSpineActive(false);
    };

    const onAfterOpen = () => {
        console.log("onAfterOpen");
    }

/* 
    React.useEffect(() => {
        if (comment.length > 0) setIsButtonDisabled(false);
        else setIsButtonDisabled(true);
    }, [commentOption, comment]);
*/

    const handleSetComment = (e) => {
        setComment(e.target.value);
        if (e.target.value.length > 0) setIsButtonDisabled(false);
        else setIsButtonDisabled(true);
    }

    const handleSetCommentOption = (option) => {
        setCommentOption(option);
        if (comment.length > 0) setIsButtonDisabled(false);
        else setIsButtonDisabled(true);
    }

    React.useEffect(() => {
        setComment(lessonData.note || "");  
    }, [lessonData.note]);

    React.useEffect(() => {
        if (!isOpen) {
            resetDrag();
        }
    }, [isOpen, resetDrag]);

    return (
            <ReactModal 
                isOpen = {isOpen} 
                onRequestClose = {onClose}
                onAfterOpen={onAfterOpen}
                            style={{
                                overlay: {
                                    backgroundColor: 'rgba(0, 0, 0, 0.65)',
                                    backdropFilter: "blur(8px)",
                                    overflow: "hidden",
                                    zIndex: MODAL_Z_INDEX_BASE,
                                },
                                content: {
                                    ...styles.modalContainer,
                                    width: isMobile ? "100%" : desktopModalWidth,
                                    maxWidth: isMobile ? "100vw" : "calc(100vw - 24px)",
                                    boxSizing: "border-box",
                                    padding: isMobile ? "14px 16px calc(16px + env(safe-area-inset-bottom))" : "30px",
                                    ...(isMobile
                                        ? {
                                            top: "auto",
                                            left: 0,
                                            right: 0,
                                            bottom: 0,
                                            ...sheetMotionStyle,
                                        }
                                        : {
                                            top: styles.modalContainer.top,
                                            left: styles.modalContainer.left,
                                            right: "auto",
                                            bottom: "auto",
                                            transform: styles.modalContainer.transform,
                                        }),
                                    maxHeight: isMobile ? "100dvh" : undefined,
                                    height: isMobile ? "auto" : desktopModalHeight,
                                    overflowY: "auto",
                                    display: "flex",
                                    flexDirection: "column",
                                    borderRadius: isMobile ? "20px 20px 0 0" : styles.modalContainer.borderRadius,
                                }
                            }}
                >
                    {isMobile && (
                        <div {...dragHandleProps}>
                            <div style={bottomSheetDragHandleVisualStyle} />
                        </div>
                    )}
                    <div style={{ display: "flex", alignItems: "center", marginBottom: 10 }}>
                        <OnestMediumDefault style={{ color: "#020202" }}>
                            {t("Заметка к уроку")}
                        </OnestMediumDefault>
                        <div style={{ flexGrow: 1 }} />
                        <button
                            type="button"
                            onClick={onClose}
                            style={{
                                border: "none",
                                background: "transparent",
                                cursor: "pointer",
                                padding: 0,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                marginTop: isMobile ? -6 : -14,
                                marginRight: isMobile ? -4 : -12,
                            }}
                            aria-label={t("Закрыть заметку")}
                        >
                            <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M18 6L6 18"
                                    stroke="#B1B1B1"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                                <path
                                    d="M6 6L18 18"
                                    stroke="#B1B1B1"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                        </button>
                    </div>
                    <textarea
                        style={{
                            ...styles.textArea,
                            width: isMobile ? "100%" : desktopInnerWidth,
                            height: 123,
                            color: "#222222",
                            backgroundColor: "#F5F5F5",
                            marginBottom: 10,
                            padding: "10px 10px",
                        }}
                        value={comment}
                        onChange={handleSetComment}
                        placeholder={t("Введите заметку")}
                    />
                    <div style={{ marginBottom: 10 }}>
                        <label style={{ ...styles.radioBoxRow, marginTop: 0 }}>
                            <RadioBoxEmpty
                                checked={commentOption === 'lesson'}
                                onChange={() => handleSetCommentOption('lesson')}
                            />
                            <OnestNormalSmall style={{ color: "#222222" }}>
                                {t("Запомнить заметку только на этот урок")}
                            </OnestNormalSmall>
                        </label>
                        <label style={{ ...styles.radioBoxRow, marginTop: 0 }}>
                            <RadioBoxEmpty
                                checked={commentOption === 'week'}
                                onChange={() => handleSetCommentOption('week')}
                            />
                            <OnestNormalSmall style={{ color: "#222222" }}>
                                {t("Запомнить заметку на неделю")}
                            </OnestNormalSmall>
                        </label>
                        <label style={{ ...styles.radioBoxRow, marginTop: 0 }}>
                            <RadioBoxEmpty
                                checked={commentOption === 'month'}
                                onChange={() => handleSetCommentOption('month')}
                            />
                            <OnestNormalSmall style={{ color: "#222222" }}>
                                {t("Запомнить заметку на месяц")}
                            </OnestNormalSmall>
                        </label>
                    </div>
                    {isSpineActive ?
                                    <div style={{ margin: "8px", alignSelf: "center", display: "flex", flexDirection: "row", alignItems: "center" }}>
                                        <ClipLoader color={color_red_default} size={35} loading={isSpineActive} />
                                        <OnestNormalDefault
                                            style={{ margin: "8px", alignSelf: "center" }}
                                        >{t("Сохранение...")}</OnestNormalDefault>
                                    </div>
                    :      
                    <Button
                        width={isMobile ? "100%" : desktopInnerWidth}
                        height={63}
                        backgroundColor={isButtonDisabled ? color_grey_light : color_red_default}
                        borderColor={isButtonDisabled ? color_grey_light : color_red_default}
                        disabled={isButtonDisabled}
                        color={color_white}
                        style={{ border: "none", marginTop: "auto" }}
                        onClick={handleCommentSubmit}>
                            <OnestNormalMed>{t("Сохранить")}</OnestNormalMed>
                    </Button>
                    }
            </ReactModal>
      
    );
};

export default ModalNote;